'use strict';

angular.module('ntmApp').factory('ActivitySkillsValidator', [function () {

    function ActivitySkillsValidator(activity, dow, header, skillsProvider) {

        var self = this;

        self.activity = activity;
        self.dow = dow;
        self.header = header;
        self.skillsProvider = skillsProvider;

        self.isValid = function () {

            if (self.activity.assignmentId !== self.header.personId) {

                var targetPersonSkills = self.skillsProvider.firstOrDefault(function (record) {
                    return record.personId === header.personId;
                });

                if (targetPersonSkills) {
                    return targetPersonSkills.staffSkillsForActivityList.some(function (skillRecord) {
                      if (skillRecord.activityId === self.activity.activityId && (skillRecord.staffSkills === null || self.activity.speciesCode === null || self.activity.speciesId === null )) {
                            return true;
                        }
                        else if (skillRecord.activityId === self.activity.activityId && skillRecord.staffSkills) {
                            var skills = skillRecord.staffSkills.split(';');
                            return skills.some(function (skill) {
                                var speciesId = self.activity.speciesId || self.activity.speciesCode;
                                return speciesId === skill;
                            });
                        }

                        return false;
                    });
                }

                return false;
            }

            return true;
        };


        self.warningMessage = function () {

            return "Warning: {0} is not qualified to perform {1}{2}. <br /><br /> {4} to {0} {3} anyway?"
                                         .format(self.header.staffName,
                                                 self.activity.activity,
                                                 self.activity.speciesName ? " for " + self.activity.speciesName.trim() : '',
                                                 moment(self.activity.dateSchedule).diff(moment(self.dow.date), 'days') !== 0 ? "and move to {0}".format(moment(self.dow.date).format('MM/DD/YYYY')) : "",
                                                 self.activity.personId ? 'Reassign' : 'Assign');
        };
    }

    return (ActivitySkillsValidator);
}]);
